import React from 'react'

import { SxProps } from '@mui/material'

import Box from 'components_new/atoms/Box'
import Icon from 'components_new/atoms/Icon'
import Link from 'components_new/atoms/Link'
import Table from 'components_new/atoms/Table'
import TableBody from 'components_new/atoms/Table/TableBody'
import TableCell from 'components_new/atoms/Table/TableCell'
import TableHead from 'components_new/atoms/Table/TableHead'
import TableRow from 'components_new/atoms/Table/TableRow'

import Endpoint from 'components_new/molecules/Endpoint'
import FormSection from 'components_new/molecules/FormSection'

import { useTranslation } from 'language/translator'

interface Props {
  sx?: SxProps
}

const ApiDetails = (props: Props) => {
  const { sx } = props

  const { t } = useTranslation()

  return (
    <Box sx={sx}>
      <FormSection
        helperText={t('dashboards', 'generate_temporary_link_helper')}
        title={t('dashboards', 'generate_temporary_link')}
      >
        <Endpoint
          href="https://api.homepal.se/v1/third-party/dashboards"
          variant="get"
        />
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>{''}</TableCell>
              <TableCell>{t('dashboards', 'key')}</TableCell>
              <TableCell>{t('dashboards', 'required')}</TableCell>
              <TableCell>{t('global', 'description')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>
                <b>{t('dashboards', 'query_parameter')}</b>
              </TableCell>
              <TableCell>
                <code>{'company_group_id'}</code>
              </TableCell>
              <TableCell>
                <Icon fontSize="small" name="Check" />
              </TableCell>
              <TableCell>
                {t('dashboards', 'create_manage_company_groups')}{' '}
                <Link href="/admin/settings/companies" newTab={true}>
                  {t('dashboards', 'companies')}
                </Link>
                .
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <b>{t('dashboards', 'header')}</b>
              </TableCell>
              <TableCell>
                <code>{'x-api-key'}</code>
              </TableCell>
              <TableCell>
                <Icon fontSize="small" name="Check" />
              </TableCell>
              <TableCell>
                {t('dashboards', 'create_manage_api_keys')}{' '}
                <Link href="/settings/api-keys" newTab={true}>
                  {t('dashboards', 'api_keys')}
                </Link>
                .
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </FormSection>
    </Box>
  )
}

export default ApiDetails
